import React from 'react'
import './blogs.css'
const Yashvardhan_Raizada = () => {
    return (
        <div className='blog'>
            <div className='container-fluid'>
                <div className='row blog-row'>
                    <div className='col-md-4'>
                        <img src='placement-postulates/dp/Yashvardhan.jpg' className='blog-dp' alt='yashvardhan'></img>
                    </div>
                    <div className='col-md-8'>
                        <div className='blog-head'>
                            <h2>Yash Vardhan Raizada</h2>
                            <small></small>
                        </div>
                    </div>
                </div>
                <div className='container-fluid'>
                    <div className='row'>
                        <div>
                        <p>Hi Everyone! </p>
      <p>
I am Yash Vardhan Raizada, currently a Final Year Undergraduate in the Department of Civil Engineering at IIT Kanpur. In the upcoming summers, after graduating, I will be joining Microsoft as a full-time employee in the role of Software Engineer.
       
      </p> 
      <p>
        <a href="https://www.linkedin.com/in/yashvardhanraizada/">LinkedIn</a>
        <br/>
        <a href="mailto:yashvardhanraizada@gmail.com">yashvardhanraizada@gmail.com</a>
        <br/>
        <a href="https://drive.google.com/file/d/1yOpgmorc39WSoIm7uc2l6TSZBtnnVKV4/view?usp=sharing">Resume</a>
      </p>

      <p>My Journey @ IITK: A brief background</p>
      <img class="blog-image-left" src="placement-postulates/blogs/Yashvardhan-Raizada/1.jpg"/>

      <p>I would like to share my background in brief about how things were for me in my initial years and how things changed over time and helped me figure out my goals in life, not limited by my career alone.</p> 

      <p>
        During the Summers just after the First Year, I was constantly looking out for options available to an undergraduate after completing the degree at IITK. The best source for me turned out to be my seniors. I used to reach out to them and ask them about their internship and placement experiences and what all roles were open etc.
      </p>

      <p>
        The same summer, I got an opportunity to work for the IITK Summer of Code, where after three months of engineering and development, my team of 5 people won the 1st Prize! This was my first exposure to Software Engineering, and I found that this was one of the fields where I was not getting bored, and I was being creative throughout the development cycle.
      </p>

      <p>
        Later on, I decided to explore the Data Science field as well though an academic project under Prof. Pranamesh Chakraborty. I even worked as a Product Analyst in a startup GreenCure founded by IITK alumni. And I did my summer internship at LTI - Larsen & Toubro Infotech.
      </p>

      <p>
        Although I was doing quite well in all these domains, LTI even offered me a PPO! But through all these experiences, I figured out a field where I was naturally interested and creative in a flow. I remember, during the Summer of Code and LTI Intern, I was doing my best, and I was not feeling any sort of significant pain, frustration or boredom even when I was working till 4 AM.
      </p>
      <img class="blog-image-right" src="placement-postulates/blogs/Yashvardhan-Raizada/2.jpg"/>
      <p>
        These were some of the major signals to me regarding what should I choose as a career option, and I started reading and interacting more and more with seniors and professionals from the Software Engineering domain, which further aligned my career goals, and I finally decided to prepare for the Software Engineering roles for the placements.
      </p>

      <p>
        <b> Some Key Decisions! </b>
      </p>

      <p>
        I would like to emphasize here that campus placements are one of the easiest ways a UG can try to choose a career path of his/her choice. So I would say, spend some time exploring yourself
and your future aspirations and decide on not more than 2-3 job profiles which you will be aiming for. And out of those, your top preference should have 70-80% approval from your side; the rest should be back up! This will help you not only do a much-focused preparation but will really help you get into the best companies in your desired job role.
      </p>

      <p>
        And when you think along these lines and interact more and more with your seniors, you will get to know not only the career aspect but many aspects of life where you will have to make similar types of choices, and you will get more and more clear about why you would like to chose a particular job role R at a company C, and how it would be helpful in your future!
      </p>

      <img class="blog-image-left" src="placement-postulates/blogs/Yashvardhan-Raizada/3.jpg"/>
      <p>
       <b> Placement Preparation </b>
      </p>
      
      <p>
        A lot of articles can be found. My preparation was mainly through LeetCode, InterviewBit, and Brainstellar. I had made up my mind to target SDE/ML and Quant/Analytics roles.
      </p>

      <p>
        InterviewBit is a great resource. I went through the tutorials on DS/Algo, articles on ML, and other CS Fundamental topics: OOP, CN, DBMS, and OS. Try to practice 2-3 questions from each basket.
      </p>

      <p>
        I also learned SQL and practiced writing queries here. Also, one can go through some of the system design questions as well to get to know more about real-world software engineering. It may help you in some of the advanced technical rounds of some startups.
      </p>

      <p>
        Besides these, I regularly attempted Weekly and Bi-Weekly contests on LeetCode, apart from solving mock assessments on LC and practicing mock interviews on IB. Be consistent in your practice; it will help you a lot!
      </p>

      <p>
        For puzzles, I practiced questions from the 50 Challenging Problems in Probability, Brainstellar, and InterviewBit puzzles sections. For aptitude, I practiced solving past CAT papers and enrolled in a placement preparation test series by PrepLeaf.
      </p>

      <p>
        But 80% of my time was spent practicing more and more DSA questions and studying ML, CS Fundamental articles on GFG, IB, Medium, etc.
      </p>

      <p>
        Regarding resumes, I would suggest everyone go through the SPO Preparation Folder. Just keep it precise and crisp, not exceeding 1 page. Make sure you are prepared to defend each and every point written on it, even from extracurriculars. Also, do get it reviewed multiple times by at least five seniors till you get satisfied.
      </p>

      <p>Day 1, Slot 1</p>

      <p>
        Our campus interviews were scheduled on December 1, and both of my interviews were scheduled during the first slot of 8 hours.
      </p>

      <p><b> Microsoft Interview: </b></p>
      <img class="blog-image-right" src="placement-postulates/blogs/Yashvardhan-Raizada/4.jpg"/>


      <p>
        Round 1 (Technical):
      </p>

      <p>
        Introduction
      </p>
 
      <p>
        Q1. Based on a partial reversal of the Linked List. 
        <br/>
        Q2. BFS Traversal on a Matrix of 0s and 1s.
      </p>

      <p>
        Resume Project based questions. <br/>
Questions on differences between C++ and Python. Why C++ used in Game Development ?
      </p>


      <p>

Be very neat in writing code. Keep it modular, use functions, give proper names to the variables. Also don’t forget to ask questions and clarify the problem and input before solving it.
      </p>

      <p>
        Round 2 (Technical + Behavioral + HR based):
      </p>
      <img class="blog-image-left" src="placement-postulates/blogs/Yashvardhan-Raizada/5.jpg"/>
      <p>
        This interview round was with a senior manager at Microsoft.
The interviewer asked me to ask questions about Microsoft or anything I wanted to know about Microsoft or its products. It was pretty behavioral and challenging.
<br/>
I asked her about the team structure, workflow, new products they were working on, and the Underwater Data Centers they are building (The interviewer was very impressed by this question. I had earlier watched a video regarding the same !).
      </p>

      <p>
        Then she asked me a question on Semaphores Design, which after some help, I was able to explain satisfactorily. I had told her during the conversation that I am not from a CS Background, so she gave me hints whenever I got stuck.
      </p>

      <p>
        The rest of the interview was about deep-diving into technologies and further questions that emerged due to our conversation. There was a good amount of verbal and technical communication that happened. Be good at it!
      </p>

      <p>Both the rounds were about 1 hour each. <br/> Result: Offer!</p>


      <p>
        <b>JPMC Interview:</b>
        
      </p>
      <p>
        Round 1 (Programming + Technical):
      </p>

      <p>
        Around 45 minutes interview.
The interviewer asked me to reverse the Linked List and write a code for it. Detailed questions and explanations of OOPS Concepts with examples. Differences between C++ and Python.
Probability questions on Expectation and Integral Evaluations.
Asked me to write the code for Dijkstra. Follow-up questions on priority queue and heaps were also asked.
      </p>

      <p>
        Round 2 (Mathematics):
      </p>

      <p>

Hard Probability problems on Expectation and Variance. Integral <br/>  brEvaluation - Medium <br/>
Joint Probability Distribution <br/>
Question on Leibnitz Theorem <br/>
Some basic math puzzles  <br/>

I solved about 3.5 questions out of 5. But the interviewer was very helpful. Discussion on life as a quantitative analyst. <br/>
For preparation, one can lookup at brainstellar.com problems and solve questions from 50 Challenging Problems in Probability.
      </p>

      <p>

Round 3 (HR):
      </p>

      <p>
        Basic HR stuff, discussion of the offer, opportunities, activities, etc. <br/>
Result: Offer!
      </p>

      <p>
        <b> The Choice! </b>
      </p>

      <img class="blog-image-right" src="placement-postulates/blogs/Yashvardhan-Raizada/6.jpg"/>

      <p>
        Now the choice among the two:
      </p>

      <p>
        Both are pretty good places to launch your career, but one should try to look at least 5-10 years ahead and plan accordingly what one aspires for. As per my research and communication with seniors, I decided to go ahead with Microsoft.
      </p>

      <p>
        The reasons were primarily based on interest and my future career goals. I had three past projects related to the development and data science, and I really enjoyed working on them. Also, I realized that my expertise and original thinking were much more profound in Programming than in Mathematics, although I enjoy both subjects. I had admired the role of a software engineer even before I had joined college, and after a lot of research and first-hand conversations, I really wanted to be a Software Engineer. Hence, I felt just a step closer to my dream job, which I had always wanted.
      </p>

      <p>
        Further looking up at the career trajectory, a Quant at JPMC starts as an analyst and later on progresses to a Quantitative Researcher at mid-levels and then as Vice President. Nature of work is more similar to Data Analyst and Data Scientist, but financial expertise takes over technical at senior positions. Good for people who want to make a career in quantitative finance.
      </p>

      <p>
        In Microsoft, most of us already know a lot about it, its career path, growth, and opportunities. If someone wants to make a career in technology and software, it is one of the best places to launch your career.

      </p>

      <p>
        <b>
          Acknowledgments</b>
      </p>

      <p>
        I would like to thank some of the best people besides my family, who, despite the lockdown and pandemic, were in constant touch with me, and without them, things would not have been possible. Thanks to my seniors, Samyak Jain (Y17), Nimish Agarwal (Y17), Himanshu Pandey (Y17), Samyak Jain (Y16), Samarthya Sahu (Y17), Shivam Kumar (Y17), and Monika Rathore (Y17) for being constant support whenever I needed your help and advice. A big thanks to my batchmates and one of my best friends Jaskeerat Singh (Y18) and Prajjwal Katiyar (Y18), for being constant buddies during my entire journey at IITK.
      </p>

      <p>
        <b>Some Useful Resources and Tips!</b>
      </p>

      <p>Some very important tips:</p>

      <p>Take care of yourself and your health. Keep it a top priority. Indulge in some form of physical activity or workout, which you can do regularly without losing out a lot of energy and disturbing your schedule and commitments. It will help you to stay motivated, healthy, and happy.</p>

      <p>

Take care of your mental health. Switch off the notification of Social Media apps if it takes away your peace of mind. Find a close friend with whom you can ease out your post-assessment stress and share your experiences. It will help you out a lot!
      </p>

      <p>
        Take ample rest, but do follow a schedule. Be in touch with your seniors; you can’t imagine how motivating and helpful their advice can be! Trust them; they have also gone through similar experiences.
      </p>

      <p>
        Resources:
      </p>

      <ul>
        <li> <a href="https://www.interviewbit.com/practice/">https://www.interviewbit.com/practice/</a> </li>
        <li> <a href="https://leetcode.com/">https://leetcode.com/</a> </li>
          <li> <a href="https://brainstellar.com/">https://brainstellar.com/</a> </li>
            <li> <a href="http://spo.iitk.ac.in/preparation/">http://spo.iitk.ac.in/preparation/</a> </li>
              <li> <a href="https://www.geeksforgeeks.org/must-do-coding-questions-for-companies-like-amazon-microsoft-adobe/">https://www.geeksforgeeks.org/must-do-coding-questions-for-companies-like-amazon-microsoft-adobe/</a> </li>
                <li> <a href="https://www.geeksforgeeks.org/machine-learning/">https://www.geeksforgeeks.org/machine-learning/</a> </li>
                  <li> <a href="https://www.linkedin.com/pulse/most-asked-interview-questions-os-dbms-cn-harsh-agar
                    wal/">https://www.linkedin.com/pulse/most-asked-interview-questions-os-dbms-cn-harsh-agar
                    wal/</a> </li>
<li><a href="https://soce-iitk.herokuapp.com/Samyak_Jain">https://soce-iitk.herokuapp.com/Samyak_Jain</a> 
        </li>
      </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Yashvardhan_Raizada